import config from '../config/config'
import axios from 'axios'

const getHeaders = () => {
    if (localStorage.getItem('token')) {
        return {
            'Authorization': localStorage.getItem('token'),
            'email': localStorage.getItem('email')
        }
    }
    else {
        return {}
    }
}

export function post(uri, data) {
    return axios.post(endpoint(uri), data, {
        headers: getHeaders()
    })
}

export function put(uri, data) {
    return axios.put(endpoint(uri), data, {
        headers: getHeaders()
    })
}

export function remove(uri, data) {
    return axios.delete(endpoint(uri), {
        data,
        headers: getHeaders()
    })
}

export function get(uri) {
    return axios.get(endpoint(uri), {
        headers: getHeaders()
    })
}

export function endpoint(uri) {
    return config.BASE_URL + uri
}
